<template>
    <div>
        <v-fade-transition mode="out-in">

                <v-img
                    width="100%"
                    height="auto"
                    v-if="screener.films[0].thumburls"
                    :src="screener.films[0].thumburls"
                >
                    <v-card height="100%" flat class="statusBoard">
                    <v-layout fill-height column  justify-space-around >
                        <v-flex xs2>
                            <v-layout row wrap justify-space-between >
                                <v-flex>
                                    <v-card-actions class="pa-3">
                                        <v-spacer></v-spacer>
                                        <v-btn hover small outline class="pa-2" color="primary" @click="$emit('leaveScreening')">{{ $t("screener.btn.leave_screening") }}</v-btn>
                                    </v-card-actions>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs8>
                            <v-container fluid fill-height>
                                <v-layout align-center justify-center>
                                <v-flex>
                                    <slot></slot>
                                </v-flex>
                                </v-layout>
                            </v-container>
                        </v-flex>
                        <v-flex xs2 >
                            <v-card color="transparent">
                                <v-card-title primary-title>
                                    <div>
                                        <h3 class="headline mb-0 white--text">{{screener.title}}</h3>
                                        <div class="grey--text screener-description">
                                            <span v-if="screener.films.length > 1 && screener.description" v-html="screener.description"></span>
                                            <span v-else v-html="screener.films[0].description"></span>
                                        </div>
                                    </div>
                                </v-card-title>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-card>
                </v-img>
        </v-fade-transition>
    </div>
</template>
<script>
import i18n from "@/i18n"
import AppLoader from "@/components/AppLoader"
export default {
    name: "EventStatusBoard",
    props: {
        eventManagerState: {
            type: String,
            default: null
        },
        screener: {
            type: Object,
            default: null
        },
        showBackgroundImage: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    components: {
        AppLoader
    },
    computed: {
        statusBoard() {
            return this.resolveEventManagerState()
        }
    },
    methods: {
        /**
         * This function is responsilbe for resolving dynamic component with event manager state
         */
        resolveEventManagerState() {
            let component = null;
            let metaData = null;

            /**
             * 1. If event manaager is initialising then simply show a loader with message
             */
            if(this.eventManagerState == this.DEFINES.EVENT_MANAGER_STATE.INITIALIZING){
                component = "AppLoader";
                metaData = {
                    message: "Please wait whilw we are fetching your screening."
                }
                return {component, metaData}
            }
        },
    }
}
</script>
<style scoped>
    .bg-image {
        position: absolute;
    }
    .statusBoard {
         background-color: rgba(1, 1, 1, 0.8) !important;
        border-color: white !important;
    }
    .screener-description {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>
